import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AppContext from 'context/Context';
import WiseNavbar from 'components/WiseNavbar';
import { Container } from 'react-bootstrap';
import { routePaths } from 'routes/routePaths';
import classNames from 'classnames';

const MainLayout = () => {
  // NOTE: MainLayout Structure changed for shorter version of Falcon react.
  // if you use kanban/ecommerce functionalities, plese check this file from full version of Falcon react.

  const { hash, pathname } = useLocation();

  const {
    config: { isFluid }
  } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={isFluid ? 'container-fluid px-0' : 'container'}>
      <div className="content">
        <WiseNavbar />
        <div className="border-bottom" />
        <Container className="mt-6">
          <div
            className={classNames('mx-auto', {
              'payment-container': pathname !== routePaths.PAY_URL
            })}
          >
            <Outlet />
          </div>
        </Container>
      </div>
    </div>
  );
};

export default MainLayout;
